import { gql } from '@apollo/client'

export const TEAM_REPORT_QUERY = gql`
  query teamReport($filter: TeamReportFilter!) {
    teamReport(filter: $filter) {
      mainPeriod {
        aivCasesCount
        capacityEmployeesInCases
        capacityEmployeesInHours
        feedbackRate
        legalAdviceCasesCount
        legalAdviceInAivCasesCount
        openCases
        selfGeneratedCasesFromLegalAdvice
        settlementRate
        total
        transferredCases
        capacityEmployeesInHours
        utilizationRateEmployees
      }
      comparisionPeriod {
        aivCasesCount
        capacityEmployeesInCases
        capacityEmployeesInHours
        feedbackRate
        legalAdviceCasesCount
        legalAdviceInAivCasesCount
        openCases
        selfGeneratedCasesFromLegalAdvice
        settlementRate
        total
        capacityEmployeesInHours
        transferredCases
        utilizationRateEmployees
      }
      trend {
        aivCasesCount
        capacityEmployeesInCases
        capacityEmployeesInHours
        feedbackRate
        legalAdviceCasesCount
        legalAdviceInAivCasesCount
        openCases
        capacityEmployeesInHours
        selfGeneratedCasesFromLegalAdvice
        settlementRate
        total
        transferredCases
        utilizationRateEmployees
      }
    }
  }
`
